import cx from './listingmodel.module.scss'
import Button from 'src/components/button/Button';
import Loader from '../loader/Loader';
import { changeFilterModalState } from 'src/store/program/program.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TfilterProps } from 'src/pages/discover/discover';
import { useEffect, useRef } from 'react';
import { TVenturefilterProps } from 'src/pages/venture/Venture';

interface TListModalProps { filter: TfilterProps | TVenturefilterProps, isListing?: boolean, setSortBy?: any, sortBy?: any, handleAction: (type: string, filterType: string) => void, handleSelect: (value: string, type, checked: boolean) => void }
export default function ListingModal({ filter, handleAction, handleSelect, isListing = false, setSortBy, sortBy }: TListModalProps) {
    const dispatch = useAppDispatch();
    const { filterModal } = useAppSelector(
        (store: any) => store.program
    );
    const modalRef = useRef<HTMLDivElement>(null);
    const handleClose = () => {
        dispatch(changeFilterModalState({ state: '', data: [] }))
    }
    function handleSort(option: string) {
        setSortBy && setSortBy(option)
    }
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (
        <div className={`${cx.toggleBox}`} ref={modalRef}>
            {!isListing && <div className={cx.topHeader}>
                <button onClick={() => handleAction('select-all', filterModal.state)}>Select all</button>
                <button onClick={() => handleAction('clear-all', filterModal.state)}>Clear all</button>
            </div>}
            <ul className={`${cx.itemList}`}>
                {filterModal?.data?.map((item, i: number) => {
                    return (
                        <li key={i} style={sortBy && sortBy === item.value ? { background: '#fff3ed', padding: '2px', borderRadius: '12px' } : sortBy ? { padding: '2px', borderRadius: '12px' } : {}}>
                            <div className="dynamic-field__field__character-limit-checkbox">
                                {!isListing && <input
                                    type="checkbox"
                                    id="characterLimit"
                                    checked={filter?.[filterModal?.state]?.includes(item?.label)}
                                    onChange={(e) => handleSelect(item.label, filterModal.state, e.target.checked)}
                                />}
                            </div>
                            <span onClick={() => isListing && handleSort(item.value)} >{item.label}</span>
                        </li>
                    )
                })}
            </ul>
            {/* <div className={cx.buttonContainer}>
                <Button
                    variant="secondary"
                    size="extraSmall"
                    onClick={handleClose}
                >
                    Close
                </Button>
            </div> */}
        </div>
    )
}
